export const GET_LOAN_INCREASES = 'loan_increases/GET_LOAN_INCREASES'
export const ADD_LOAN_INCREASE = 'loan_increases/ADD_LOAN_INCREASE'
export const EDIT_LOAN_INCREASE = 'loan_increases/EDIT_LOAN_INCREASE'
export const SUBMIT_LOAN_INCREASE = 'loan_increases/SUBMIT_LOAN_INCREASE'
export const APPROVE_LOAN_INCREASE = 'loan_increases/APPROVE_LOAN_INCREASE'
export const REJECT_LOAN_INCREASE = 'loan_increases/REJECT_LOAN_INCREASE'
export const DELETE_LOAN_INCREASE = 'loan_increases/DELETE_LOAN_INCREASE'
export const START_LOADING_LOAN_INCREASE = 'loan_increases/START_LOADING_LOAN_INCREASE'
export const STOP_LOADING_LOAN_INCREASE = 'loan_increases/STOP_LOADING_LOAN_INCREASE'
